<template>
  <v-simple-table class="promotion-card__components-table">
    <thead>
      <tr>
        <th>{{ $t('entities.promotions.card.component') }}</th>
        <th class="text-center promotion-card__components-small-column">
          {{ $t('entities.promotions.card.variants') }}
        </th>
        <th class="text-center promotion-card__components-small-column">
          {{ $t('generalAttributes.quantity') }}
        </th>
        <th class="text-center promotion-card__components-actions">
          {{ $t('miscellaneous.actions') }}
        </th>
      </tr>
    </thead>
    <tbody v-if="hasGroups">
      <tr v-for="group in groups" :key="getGroupKey(group)">
        <td>
          {{ group.name || '—' }}
        </td>
        <td class="text-center promotion-card__components-small-column">
          {{ getVariantCount(group.variants) }}
        </td>
        <td class="text-center promotion-card__components-small-column">
          <span class="promotion-card__components-quantity">
            {{ group.quantity || 0 }}
            <CoinIcon
              v-if="isCoinsGroup(group)"
              class="promotion-card__components-coin-icon" />
          </span>
        </td>
        <td class="text-center promotion-card__components-actions">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="primary"
                depressed
                :disabled="!isEditing"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('edit-group', group)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('entities.promotions.card.tooltips.editComponent') }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="error"
                depressed
                :disabled="!isEditing || isGroupDeleting(group)"
                :loading="isGroupDeleting(group)"
                v-bind="attrs"
                v-on="on"
                @click="$emit('delete-group', group)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('entities.promotions.card.tooltips.deleteComponent') }}
            </span>
          </v-tooltip>
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td :colspan="4" class="text-center grey--text">
          {{ $t('entities.promotions.card.noComponents') }}
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import CoinIcon from '@/components/CoinIcon.vue'

const COINS_CATEGORY_CODE = 'CNS'

export default {
  name: 'PromotionComponentsTable',
  components: { CoinIcon },
  props: {
    promotion: { type: Object, required: true },
    categories: { type: Array, default: () => [] },
    isEditing: { type: Boolean, default: false },
    isGroupDeleting: { type: Function, default: () => () => false },
  },
  computed: {
    groups() {
      return Array.isArray(this.promotion?.groups) ? this.promotion.groups : []
    },
    hasGroups() {
      return this.groups.length > 0
    },
  },
  methods: {
    getGroupKey(group) {
      if (!group) return ''
      return group.id || group.tempId || group.name || ''
    },
    getVariantCount(variants) {
      if (!Array.isArray(variants)) return 0
      return variants.length
    },
    getGroupCategoryCode(group) {
      if (!group || !this.categories?.length) return ''
      const matchedCategory = this.categories.find(
        (it) => it.id === group.category_id,
      )
      return matchedCategory.code
    },
    isCoinsGroup(group) {
      return this.getGroupCategoryCode(group) === COINS_CATEGORY_CODE
    },
  },
}
</script>

<style scoped>
.promotion-card__components-table {
  width: 100%;
}

.promotion-card__components-table th,
.promotion-card__components-table td {
  border-bottom: 1px solid #d7dce6 !important;
  vertical-align: middle;
  padding: 0 0.25rem !important;
}

.promotion-card__components-actions {
  min-width: 4.75rem;
}

.promotion-card__components-small-column {
  min-width: 3.75rem;
}

.promotion-card__components-quantity {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.promotion-card__components-coin-icon {
  margin-bottom: 0.125rem;
  width: 1rem;
  height: 1rem;
}
</style>
